// extracted by mini-css-extract-plugin
export var minimized = "navigation-module--minimized--HXE8W";
export var maximized = "navigation-module--maximized--CgClT";
export var firstX = "navigation-module--firstX--tzzIr";
export var secondX = "navigation-module--secondX--xRUXc";
export var x = "navigation-module--x--LQRDx";